import MarqueeLib from "react-fast-marquee";

const items = ["Crunchy", "Spicy", "Proppa Tasty", "Perfect with a Pint", "Wholesale Available"];

export const Marquee = () => (
  <div className="bg-[#FF6B00] py-5 overflow-hidden" data-testid="editorial-marquee">
    <MarqueeLib speed={45} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-24 mr-24">
          <span className="font-display text-3xl lg:text-4xl font-bold uppercase tracking-tight text-[#2B0B3C] whitespace-nowrap">
            {item}
          </span>
          <span className="w-3 h-3 rotate-45 bg-[#4A148C] inline-block border-2 border-[#2B0B3C]" />
        </span>
      ))}
    </MarqueeLib>
  </div>
);
